<template>
  <div id="app">
    <Loading v-show="!showContainer"></Loading>
    <router-view v-show="showContainer"> </router-view>
    <CursorWrap></CursorWrap>
  </div>
</template>

<script>
import CursorWrap from "./components/CursorWrap";
import Loading from "./components/Loading";

export default {
  name: "App",
  components: {
    CursorWrap,
    Loading
  },
  data() {
    return {
      showContainer: false
    };
  },
  created() {
    setTimeout(() => {
      this.showContainer = true;
    }, 4500);
  }
};
</script>

<style scoped>
#app {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #080b13;
  background-image: url("./assets/images/logo/bg_img.png");
  background-repeat: no-repeat;
  background-size: 300%;
  background-position: center;

  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  color: white;
  font-family: Helvetica, Arial, PingFang SC, Hiragino Sans GB, Microsoft YaHei,
    sans-serif;
  white-space: nowrap;
  min-height: 100vh;
  min-width: 1100px;
  font-weight: lighter;
  overflow: auto;
}
</style>
